import styled from "styled-components";
import { Button } from "./shared";
import { colors } from "../theme/colors";

export const LobbyBackground = styled.div`
  min-height: 100vh;
  box-sizing: border-box;
  color: #fff;
  text-align: center;
  background-image: url("/images/bg_blue.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
`;

export const LobbyContent = styled.div`
  flex: 1;
  position: relative;
  padding: 1.5rem 2.5rem 2.5rem;

  @media (max-width: 600px) {
    padding: 1.5rem 1rem 2rem;
  }
`;

export const WelcomeHeading = styled.h1`
  margin-top: 3.25rem;
  font-size: 1.75rem;
  text-transform: uppercase;
  text-shadow: 2px 2px 6px rgba(0, 0, 0, 0.3);
`;

export const LogoRow = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: 0.25rem;
  margin-top: 0.5rem;
`;

export const LogoImg = styled.img`
  height: 6.875rem;

  @media (max-width: 480px) {
    height: 4.5rem;
  }
`;

export const StepDots = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.25rem;
  margin: 1.25rem 0 1.25rem;

  span:first-child {
    width: 1.25rem;
    height: 0.25rem;
    border-radius: 2px;
    background: ${colors.orange};
  }

  span:not(:first-child) {
    width: 0.25rem;
    height: 0.25rem;
    border-radius: 50%;
    background: ${colors.orange};
    opacity: 0.4;
  }
`;

export const CarouselDots = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.375rem;
  margin-top: 0.625rem;

  span:first-child {
    width: 1.25rem;
    height: 0.25rem;
    border-radius: 2px;
    background: #fff;
  }

  span:not(:first-child) {
    width: 0.25rem;
    height: 0.25rem;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.6);
  }
`;

export const RulesCard = styled.div`
  background: #fff;
  border-radius: 1rem;
  padding: 3rem;
  max-width: 46.875rem;
  margin: 2.5rem auto 0;
  color: ${colors.black};

  h2 {
    color: ${colors.black};
    font-size: 1.0625rem;
    margin: 0;
  }

  @media (max-width: 600px) {
    padding: 1.5rem;
  }
`;

export const LobbyFooterBar = styled.div`
  background: #fff;
  padding: 0.75rem 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0.5rem 1rem;
  position: relative;
`;

export const JazzLogoImg = styled.img`
  height: 1.5rem;
`;

export const RegulatoryCode = styled.span`
  color: #333;
  font-size: 0.6875rem;
  position: absolute;
  right: 1.5rem;

  @media (max-width: 480px) {
    position: static;
  }
`;

export const PillButton = styled(Button)`
  background: #fff;
  color: #1a237e;
  border: none;
  border-radius: 999px;
  padding: 0.625rem 1.125rem;
  font-weight: bold;
  font-size: 0.6875rem;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
`;

// Bleeds off the edge of the screen, matching the clipped-pill design used throughout the app.
// Defaults to clipping the left edge; pass $side="right" to mirror it for a button on the right.
export const ClippedPillButton = styled(PillButton)<{ $side?: "left" | "right" }>`
  ${(props) =>
    props.$side === "right"
      ? `padding-right: 1.875rem; margin-right: -3.75rem;`
      : `padding-left: 1.875rem; margin-left: -3.75rem;`}

  @media (max-width: 480px) {
    ${(props) =>
      props.$side === "right"
        ? `padding-right: 1.25rem; margin-right: -1.875rem;`
        : `padding-left: 1.25rem; margin-left: -1.875rem;`}
  }
`;

export const TeamLabelCorner = styled.p`
  position: absolute;
  bottom: 1rem;
  left: 2.5rem;
  font-weight: bold;
  margin: 0;

  @media (max-width: 600px) {
    left: 1rem;
  }
`;
